import { render, staticRenderFns } from "./ManagedServicesList.vue?vue&type=template&id=046d741a&scoped=true&"
import script from "./ManagedServicesList.vue?vue&type=script&lang=js&"
export * from "./ManagedServicesList.vue?vue&type=script&lang=js&"
import style0 from "./ManagedServicesList.vue?vue&type=style&index=0&id=046d741a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d741a",
  null
  
)

export default component.exports